export function maskString(originalString: string): string {
  return originalString
    .split(" ")
    .map((word) => {
      if (word.length === 0) {
        return ""
      }
      if (word.length === 1) {
        return "*"
      }
      if (word.length === 2) {
        return word[0] + "*".repeat(word.length - 1)
      }
      return word[0] + "*".repeat(word.length - 2) + word[word.length - 1]
    })
    .join(" ")
}

export function maskPhoneNumber(phone: string): string {
  // 마지막 하이픈(-) 뒤의 숫자를 모두 마스킹한다.
  // 예: 010-1234-5678 -> 010-1234-****, 1544-7777 -> 1544-****
  const lastHyphenIndex = phone.lastIndexOf("-")
  if (lastHyphenIndex === -1) {
    return phone
  }
  const prefix = phone.slice(0, lastHyphenIndex + 1)
  const rest = phone.slice(lastHyphenIndex + 1)
  return prefix + rest.replace(/\d/g, "*")
}

const MAX_PRODUCT_NAME_MASK_LENGTH = 5

export function maskProductName(productName: string): string {
  // 상품명 전체를 한 덩어리로 보고 맨 앞뒤 한 글자만 남긴다. 공백을 기준으로
  // 단어별 마스킹하는 maskString 과 달리, 단어 경계가 남으면 상품을 알아볼 수 있다.
  // 별표는 최대 5개까지만 찍는다. 상품명은 이름과 달리 수십 자에 이르는 경우가
  // 흔해서, 길이만큼 찍으면 화면이 별표로 뒤덮인다.
  // 예: 나이키 에어포스1 화이트 -> 나*****트
  if (productName.length === 0) {
    return ""
  }
  if (productName.length === 1) {
    return "*"
  }
  if (productName.length === 2) {
    return productName[0] + "*"
  }
  const maskLength = Math.min(
    productName.length - 2,
    MAX_PRODUCT_NAME_MASK_LENGTH
  )
  return (
    productName[0] +
    "*".repeat(maskLength) +
    productName[productName.length - 1]
  )
}
